import { render, staticRenderFns } from "./Storybook.vue?vue&type=template&id=28c6f735&scoped=true&"
import script from "./Storybook.vue?vue&type=script&lang=ts&"
export * from "./Storybook.vue?vue&type=script&lang=ts&"
import style0 from "./Storybook.vue?vue&type=style&index=0&id=28c6f735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6f735",
  null
  
)

export default component.exports